$('label.main_coll_click').click(function(){
   var name = $(this).attr('attr_name');
   $( ".hide_div" ).each(function( index ) {
    var name2 = $(this).attr('var_title');
     var price = $(this).attr('price');
       if(name == name2){
           var id = $(this).attr('data-variant-id');
           $('button.custom_addtocart').attr('var_id',id)
           $('.product_price_noty').text(price);
       }
   });
});


$(document).ready(function () {
  var last = localStorage.getItem("submit");
  if (last == "true") {
    $("body").addClass("submit_footer");
  } else {
    $("body").removeClass("submit_footer");
  }
var name = $('body .product-form__input--pill input[type=radio]:checked+label').attr('attr_name');
  console.log(name);
   // $( ".hide_div" ).each(function( index ) {
   //  var name2 = $(this).attr('var_title');
   //    var price = $(this).attr('price');
   //     if(name == name2){
   //         var id = $(this).attr('data-variant-id');
   //         $('button.custom_addtocart').attr('var_id',id)
   //         $('.product_price_noty').text(price);
   //     }
   // });
});

$(".cart-svg svg").click(function () {
  var elements = $("[attr_check='true']");
  elements.removeClass("open_thanks");
  var currentUrl = window.location.href;
  var questionMarkIndex = currentUrl.indexOf("?");
  if (questionMarkIndex !== -1) {
    var newUrl = currentUrl.substring(0, questionMarkIndex);
    window.history.pushState({}, document.title, newUrl);
  }
  localStorage.setItem("check", false);
  $("body").removeClass("show_pop");
});

// cart notification
$(document).on("click", "button.custom_addtocart", function () {
  console.log('work');
  var id = $(this).attr("var_id");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: 1,
      id: id,
    },
    dataType: "json",
    success: function (data) {
      $("product-info .cart-notify").addClass("notify_active");
      interval = setInterval(function () {
        $("product-info .cart-notify").removeClass("notify_active");
        clearInterval(interval);
      }, 3000);
    },
  });
});

$(document).on("click", "button.close_svg", function () {
  $("product-info .cart-notify").removeClass("notify_active");
});

$(document).on("click", ".new_button_sbmt", function () {
  localStorage.setItem("submit", "true");
});

// cart notification

$(".mobile_check_main").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  prevArrow:
    "<button type='button' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='20px' height='20px' viewBox='0 0 512 512'><path d='M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z'/></svg></button>",
  nextArrow:
    "<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='20px' height='20px' viewBox='0 0 512 512'><path d='M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z'/></svg></button>",
});
